import React, { useState } from "react";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const SendBulkEmail = () => {
  const [message, setMessage] = useState("");

  const sendToAll = async () => {
    const res = await fetch("/api/emails/send", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ message }),
    });

    if (res.ok) {
      setMessage("");
      toast.success("Emails sent to all!");
    } else {
      toast.error("Failed to send emails.");
    }
  };

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">Send Bulk Email</h2>
      <Textarea
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Write your message here..."
        className="min-h-[150px]"
      />
      <Button onClick={sendToAll}>Send to All</Button>
    </div>
  );
};

export default SendBulkEmail;
